import React from 'react';
import { useRecoilState } from 'recoil';
import { makeStyles, createStyles } from '@material-ui/core';
import { Table, TableHead, TableRow, TableBody } from '@material-ui/core';
import { StyledTableCell } from '../Style';
import { mainBlueColor } from '../../../GlobalState';
import { parsePrice } from '../../../utils';
import {
  TAggregateResult,
  TAdditionalParam
} from '../../../types/estimate/estimate';

type TProps = {
  aggregateResults: TAggregateResult;
  additionalParam: TAdditionalParam;
};

const SummaryTable = React.memo((props: TProps) => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const { aggregateResults, additionalParam } = props;
  const classes = useStyles({ mainColor });

  return (
    <Table style={{ minWidth: 1200 }} aria-label='customized table'>
      <TableHead>
        <TableRow>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            内訳合計（定価合計）
          </StyledTableCell>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            消費税
          </StyledTableCell>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            合計金額
          </StyledTableCell>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            原価合計
          </StyledTableCell>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            税別粗利
          </StyledTableCell>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            粗利率
          </StyledTableCell>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            日毎粗利
          </StyledTableCell>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            追加原価合計
          </StyledTableCell>
          <StyledTableCell
            style={{ width: 150 }}
            className={classes.table}
            align='center'
          >
            最終粗利率
          </StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <StyledTableCell className={classes.tableBodyPrice} align='right'>
          <div>{parsePrice(aggregateResults.sellingPriceTotal)}</div>
        </StyledTableCell>
        <StyledTableCell className={classes.tableBodyPrice} align='right'>
          <div>{parsePrice(aggregateResults.taxTotal)}</div>
        </StyledTableCell>
        <StyledTableCell className={classes.tableBodyPrice} align='right'>
          <div>{parsePrice(aggregateResults.billingTotal)}</div>
        </StyledTableCell>
        <StyledTableCell className={classes.tableBodyPrice} align='right'>
          <div>{parsePrice(aggregateResults.costPriceTotal)}</div>
        </StyledTableCell>
        <StyledTableCell className={classes.tableBodyPrice} align='right'>
          <div>{parsePrice(aggregateResults.grossProfitTotal)}</div>
        </StyledTableCell>
        <StyledTableCell style={{ backgroundColor: '#F5F5F5' }} align='center'>
          <div>{aggregateResults.grossProfitMarginTotal}%</div>
        </StyledTableCell>
        <StyledTableCell className={classes.tableBodyPrice} align='right'>
          <div>{parsePrice(aggregateResults.dailyUnitPrice)}</div>
        </StyledTableCell>
        <StyledTableCell className={classes.tableBodyPrice} align='right'>
          <div>{parsePrice(additionalParam.additionalCost)}</div>
        </StyledTableCell>
        <StyledTableCell className={classes.tableBodyPrice} align='right'>
          <div>{`${additionalParam.finalGrossProfitMargin}%`}</div>
        </StyledTableCell>
      </TableBody>
    </Table>
  );
});

export default SummaryTable;

type StyleProps = {
  mainColor: string;
};

const useStyles = makeStyles(() =>
  createStyles({
    table: {
      padding: 8,
      backgroundColor: ({ mainColor }: StyleProps) => `${mainColor} !important`,
      color: '#FFFFFF',
      fontWeight: 'bold',
      width: 150
    },
    tableBodyPrice: {
      backgroundColor: '#F5F5F5',
      paddingRight: 15
    }
  })
);
